import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFilePowerPoint = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFilePowerPoint needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C11.8879 2.00068 11.7761 2.01268 11.6663 2.03581L11.6647 2.03418L3.35742 3.69596L3.35579 3.69759C2.9748 3.76993 2.63095 3.97285 2.38348 4.27143C2.136 4.57 2.00039 4.94553 2 5.33333V18.6667C2.00008 19.055 2.13575 19.4311 2.38358 19.73C2.63142 20.029 2.97585 20.232 3.35742 20.304L11.6647 21.9658C11.775 21.9885 11.8874 22 12 22C12.442 22 12.866 21.8244 13.1785 21.5118C13.4911 21.1993 13.6667 20.7754 13.6667 20.3333V3.66667C13.6667 3.22464 13.4911 2.80072 13.1785 2.48816C12.866 2.17559 12.442 2 12 2ZM15.3333 3.66667V7.98633C15.595 7.89299 15.8725 7.83333 16.1667 7.83333V10.3333H18.6667C18.6667 11.7142 17.5475 12.8333 16.1667 12.8333C15.8725 12.8333 15.595 12.7737 15.3333 12.6803V15.3333H19.5C19.96 15.3333 20.3333 15.7067 20.3333 16.1667C20.3333 16.6267 19.96 17 19.5 17H15.3333V20.3333H20.3333C21.2542 20.3333 22 19.5875 22 18.6667V5.33333C22 4.4125 21.2542 3.66667 20.3333 3.66667H15.3333ZM17.8333 6.16667C19.2142 6.16667 20.3333 7.28583 20.3333 8.66667H17.8333V6.16667ZM5.33333 7.83333H8.27279C10.3728 7.83333 11.4238 8.71875 11.4238 10.4896C11.4238 11.3262 11.123 12.0017 10.5205 12.5192C9.91801 13.0359 9.11264 13.2956 8.10514 13.2956H7.20996V16.1667H5.33333V7.83333ZM7.20996 9.27539V11.873H7.94889C8.94806 11.873 9.44792 11.4354 9.44792 10.5596C9.44792 9.70374 8.94889 9.27539 7.94889 9.27539H7.20996Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFilePowerPoint.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFilePowerPoint;
